import { LatencySample } from '../../../services/networkLatencyObserver';

type LatencyValueSelector = (sample: LatencySample) => number | undefined;

const selectDurationMs: LatencyValueSelector = (sample) => sample.durationMs;

export const computeWeightedAverageLatency = (
  samples: LatencySample[],
  selectValue: LatencyValueSelector = selectDurationMs,
): number | undefined => {
  const { totalWeight, weightedSum } = samples.reduce(
    (accumulator, sample) => {
      const value = selectValue(sample);

      if (value === undefined) {
        return accumulator;
      }

      return {
        totalWeight: accumulator.totalWeight + sample.weight,
        weightedSum: accumulator.weightedSum + sample.weight * value,
      };
    },
    { totalWeight: 0, weightedSum: 0 },
  );

  if (totalWeight <= 0) {
    return undefined;
  }

  return weightedSum / totalWeight;
};
